import classNames from "classnames";
import styles from "./AscTrackBannerCard.module.scss";
import { CheckActiveIcon } from "../../AscIcons";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscGenericCard from "../AscGenericCard/AscGenericCard";

export interface AscTrackBannerCardProps {
  loading?: boolean;
  textOrHtml: string;
  className?: string;
}

export default function AscTrackBannerCard({
  textOrHtml,
  className,
  loading=false
}: AscTrackBannerCardProps) {
  return (
    <AscGenericCard
      title={null}
      coverImageUrl={null}
      className={classNames(styles.ground, className)}
      data-testid="asc-track-banner-card"
      loading={loading}
    >
      <div className={styles.container}>
        <CheckActiveIcon className={styles.checkIcon} />
        <AscParagraph>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: textOrHtml }}
          />
        </AscParagraph>
      </div>
    </AscGenericCard>
  );
}
